import { P2GBox } from '@parcel2go/core-ui';
import { P2GFade } from '@parcel2go/core-ui';
import { P2GText } from '@parcel2go/core-ui';
import { ReactNode } from 'react';

interface props {
  title?: string | ReactNode;
  intro?: ReactNode;
  subText?: string | ReactNode;
  children?: ReactNode;
  titleAdornment?: ReactNode;
}

export const SidePanelContent: React.FC<{ children?: ReactNode }> = (props) => {
  return (
    <P2GBox display="flex" flexDirection="column" gap={1}>
      {props.children}
    </P2GBox>
  );
};

export const SidePanelSections: React.FC<{ children?: ReactNode }> = (props) => {
  return (
    <P2GBox display="flex" flexDirection="column" gap={4}>
      {props.children}
    </P2GBox>
  );
};

export const SidePanelSectionTitle: React.FC<{ title: string | ReactNode }> = (props) => {
  return (
    <P2GText variant="subtitle2" component="div">
      {props.title}
    </P2GText>
  );
};

const SidePanelSection: React.FC<props> = (props) => {
  return (
    <P2GFade in>
      <P2GBox display="flex" flexDirection="column" gap={1}>
        {props.title && (
          <>
            {props.titleAdornment ? (
              <P2GBox
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'space-between',
                  direction: 'row',
                  flexWrap: 'nowrap'
                }}
              >
                <SidePanelSectionTitle title={props.title} />
                {props.titleAdornment}
              </P2GBox>
            ) : (
              <SidePanelSectionTitle title={props.title} />
            )}
            {props.subText && <P2GBox>{props.subText}</P2GBox>}
          </>
        )}
        {props.intro && <P2GBox>{props.intro}</P2GBox>}
        <P2GBox>{props.children}</P2GBox>
      </P2GBox>
    </P2GFade>
  );
};
export default SidePanelSection;
